import styles from "./ExtendedReturnsPolicy.module.scss";

export function ExtendedReturnsPolicy() {
  return (
    <div>
      <p className={styles.headline}>Our extended Christmas returns policy</p>
      <p>
        We&apos;ve extended our usual limit for returns just for the festive
        season. Any gift bought between 27 September 2023 and 24 December 2023
        can be returned up until 23 January 2024, if it&apos;s unwanted or
        unsuitable.
      </p>
    </div>
  );
}
